import React, { useState } from 'react';
import './interactive.css';

const MedievalPreview = () => {
  const [activeTab, setActiveTab] = useState('play');
  const [isIframeLoaded, setIsIframeLoaded] = useState(false);
  const [pathfindingStep, setPathfindingStep] = useState(3);
  const [socketLatency, setSocketLatency] = useState(24);

  const simulateTick = () => {
    setSocketLatency(Math.floor(18 + Math.random() * 12));
    setPathfindingStep((prev) => (prev % 6) + 1);
  };

  return (
    <div className="interactive-box">
      <div className="interactive-header">
        <div className="interactive-title">
          <i className="fas fa-gamepad" style={{ color: '#8b5cf6' }}></i> Medieval TD PvP – Multiplayer Arena
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <span style={{ fontSize: '0.72rem', color: '#4ade80', display: 'flex', alignItems: 'center', gap: '0.35rem' }}>
            <span style={{ width: '7px', height: '7px', borderRadius: '50%', background: '#4ade80' }}></span>
            Game Server Online
          </span>
        </div>
      </div>

      <div className="interactive-content">
        <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1.25rem', flexWrap: 'wrap' }}>
          <button
            type="button"
            className={`ansible-btn ${activeTab === 'play' ? '' : 'ansible-btn--secondary'}`}
            style={{ padding: '0.4rem 0.9rem', fontSize: '0.78rem' }}
            onClick={() => setActiveTab('play')}
          >
            <i className="fas fa-play-circle"></i> Speel Direct in Browser
          </button>
          <button
            type="button"
            className={`ansible-btn ${activeTab === 'pathfinding' ? '' : 'ansible-btn--secondary'}`}
            style={{ padding: '0.4rem 0.9rem', fontSize: '0.78rem' }}
            onClick={() => setActiveTab('pathfinding')}
          >
            <i className="fas fa-route"></i> A* Pathfinding Algoritme
          </button>
          <button
            type="button"
            className={`ansible-btn ${activeTab === 'multiplayer' ? '' : 'ansible-btn--secondary'}`}
            style={{ padding: '0.4rem 0.9rem', fontSize: '0.78rem' }}
            onClick={() => setActiveTab('multiplayer')}
          >
            <i className="fas fa-network-wired"></i> Socket.IO Realtime Netwerk
          </button>
        </div>

        {activeTab === 'play' && (
          <div>
            {!isIframeLoaded ? (
              <div className="interactive-detail-card" style={{ padding: '2rem 1rem', textAlign: 'center' }}>
                <i className="fas fa-chess-rook" style={{ fontSize: '2.5rem', color: '#8b5cf6', marginBottom: '0.75rem', display: 'block' }}></i>
                <h4 style={{ color: 'var(--title-color)', fontSize: '1.15rem', marginBottom: '0.4rem', fontWeight: 700 }}>Medieval TD PvP Live Game Arena</h4>
                <p style={{ color: 'var(--text-color)', fontSize: '0.84rem', maxWidth: '500px', margin: '0 auto 1.25rem auto' }}>
                  Speel live tegen een tegenspeler in realtime. Verdedig je koninkrijk met torens of spawn aanvallende troepen via Socket.IO kamers.
                </p>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '0.75rem', flexWrap: 'wrap' }}>
                  <button
                    type="button"
                    className="ansible-btn"
                    style={{ background: '#8b5cf6' }}
                    onClick={() => setIsIframeLoaded(true)}
                  >
                    <i className="fas fa-play"></i> Laad Spel in deze Pagina
                  </button>
                  <a
                    href="https://towerdefence.bramplatier.nl/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ansible-btn ansible-btn--secondary"
                  >
                    <i className="fas fa-external-link-alt"></i> Open in Volledig Scherm
                  </a>
                </div>
              </div>
            ) : (
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
                  <span style={{ fontSize: '0.75rem', color: 'var(--text-color)' }}>
                    Live instantie draait via HTML5 Canvas + WebSockets
                  </span>
                  <button
                    type="button"
                    onClick={() => setIsIframeLoaded(false)}
                    style={{ background: 'transparent', border: 'none', color: '#f87171', fontSize: '0.75rem', cursor: 'pointer' }}
                  >
                    <i className="fas fa-times"></i> Sluit game speler
                  </button>
                </div>
                <div className="rsc-iframe-shell" style={{ height: '540px' }}>
                  <iframe
                    src="https://towerdefence.bramplatier.nl/"
                    title="Medieval TD PvP"
                    className="rsc-iframe"
                    allow="fullscreen"
                  />
                </div>
              </div>
            )}
          </div>
        )}

        {activeTab === 'pathfinding' && (
          <div className="interactive-detail-card">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
              <div style={{ fontWeight: 600, color: '#0284c7', fontSize: '0.84rem' }}>
                <i className="fas fa-project-diagram"></i> Dynamische A* (A-Star) Pathfinding Berekening:
              </div>
              <button
                type="button"
                className="ansible-btn"
                style={{ padding: '0.25rem 0.65rem', fontSize: '0.72rem', background: '#3b82f6' }}
                onClick={simulateTick}
              >
                <i className="fas fa-sync-alt"></i> Bereken Nieuwe Route (Stap {pathfindingStep}/6)
              </button>
            </div>

            <p style={{ fontSize: '0.8rem', color: 'var(--text-color)', margin: '0 0 1rem 0' }}>
              Wanneer een speler een nieuwe toren op het speelveld plaatst, berekent het A* algoritme direct de kortste route voor vijandelijke troepen om obstakels heen:
            </p>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(8, 1fr)', gap: '4px', maxWidth: '420px', margin: '0 auto 1rem auto', background: 'rgba(0,0,0,0.05)', padding: '8px', borderRadius: '8px', border: '1px solid rgba(0,0,0,0.08)' }}>
              {Array.from({ length: 32 }).map((_, idx) => {
                const isStart = idx === 0;
                const isGoal = idx === 31;
                const isObstacle = [10, 11, 18, 19, 21].includes(idx);
                const isPath = [1, 2, 3, 12, 20, 28, 29, 30].includes(idx);
                let bg = 'rgba(128,128,128,0.12)';
                let label = '';
                if (isStart) { bg = '#3b82f6'; label = 'Spawn'; }
                else if (isGoal) { bg = '#ef4444'; label = 'Kasteel'; }
                else if (isObstacle) { bg = '#475569'; label = 'Toren'; }
                else if (isPath) { bg = '#8b5cf6'; label = '•'; }

                return (
                  <div
                    key={idx}
                    style={{
                      aspectRatio: '1',
                      background: bg,
                      borderRadius: '4px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '0.62rem',
                      color: '#fff',
                      fontWeight: 'bold',
                      border: '1px solid rgba(0,0,0,0.08)'
                    }}
                  >
                    {label}
                  </div>
                );
              })}
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', fontSize: '0.72rem', color: 'var(--text-color)' }}>
              <span><strong style={{ color: '#3b82f6' }}>Blauw:</strong> Spawn</span>
              <span><strong style={{ color: '#475569' }}>Grijs:</strong> Geplaatste Torens</span>
              <span><strong style={{ color: '#8b5cf6' }}>Paars:</strong> Berekend A* Pad</span>
              <span><strong style={{ color: '#ef4444' }}>Rood:</strong> Doel / Kasteel</span>
            </div>
          </div>
        )}

        {activeTab === 'multiplayer' && (
          <div className="interactive-detail-card" style={{ lineHeight: '1.7' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
              <div style={{ fontWeight: 'bold', color: '#0284c7' }}>
                <i className="fas fa-server"></i> Socket.IO WebSocket State Synchronization:
              </div>
              <span style={{ fontSize: '0.72rem', background: 'rgba(74, 222, 128, 0.15)', color: '#10b981', padding: '0.2rem 0.55rem', borderRadius: '4px', fontWeight: 600 }}>
                Latency: ~{socketLatency} ms
              </span>
            </div>
            <ul style={{ listStyle: 'disc', paddingLeft: '1.25rem', color: 'var(--text-color)', margin: 0 }}>
              <li><strong>Room Matchmaking:</strong> Automatische koppeling van 2 spelers via unieke room id's (Verdediger vs. Aanvaller).</li>
              <li><strong>Server-Authoritative Game Loop:</strong> Berekening van schade en projectielhits gebeurt server-side om manipulatie te voorkomen.</li>
              <li><strong>60 FPS Canvas Rendering:</strong> Smooth rendering via requestAnimationFrame op de client.</li>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default MedievalPreview;
